/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/5/2023
 */


import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeletePopUp from '../Shared/DeletePopUp';
import { toast } from 'react-toastify';
import { closeBrPrivModal } from '../../Store/Slices/brPrivSlice';
import { useDeleteMappingMutation } from '../../Store/Services/brPrivService';

const DeleteBrPriv = () => {

    const dispatch = useDispatch();
    const brPriv = useSelector((state) => state.brPriv);

    const [deleteBrPriv] = useDeleteMappingMutation();

    const onDeleteConfirm = async () => {
        const id = brPriv.selectedBrPriv;
        try {
            const response = await deleteBrPriv(id);
            const deletedBrPriv = response.data;            
            toast.success("BrPriv successfully deleted!", {position:'bottom-right'});
        } catch (err) {
            console.error('Failed to delete the brPriv: ', err)
            toast.error("Erorr, something went wrong!", {position:'bottom-right'});
        }
        dispatch(closeBrPrivModal());
    }

    return (
        <DeletePopUp
            data="Privilege mapping to the Role"
            close={() => dispatch(closeBrPrivModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    )
}

export default DeleteBrPriv